import React from "react";

import { IgTooltip, IgTypography } from "@intelligems/ig-theme";
import { InfoOutlined } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";

import theme from "../../../theme";
import { GraphConfig } from "../Graphs/Utils/graphConfigs";
import { findTooltip } from "../Graphs/Utils/graphHelpers";
import {
  headerFontSize,
  headerFontWeight,
} from "../Graphs/Utils/graphStyleCustoms";
import { graphTooltips } from "../Graphs/Utils/graphTooltips";

interface GraphHeaderDetailsProps {
  config: GraphConfig;
  metricFilterIndex?: number;
}
export const GraphHeaderDetails = ({
  config,
  metricFilterIndex,
}: GraphHeaderDetailsProps) => {
  return (
    <Grid item>
      <Grid item container direction={"row"} justifyContent={"center"}>
        <div
          style={{
            marginLeft: config.isImpactGraph ? "0px" : "10px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            // marginBottom: "10px",
            justifyContent: "space-between",
          }}
        >
          <IgTypography
            sx={{ fontWeight: headerFontWeight, fontSize: headerFontSize }}
          >
            {config.title[metricFilterIndex || 0]}
          </IgTypography>
          {findTooltip(config, graphTooltips, metricFilterIndex) !== null && (
            <IgTooltip
              title={
                <p>{findTooltip(config, graphTooltips, metricFilterIndex)}</p>
              }
            >
              <IconButton size={"small"} aria-label="info">
                <InfoOutlined sx={{ fontSize: "18px" }} fontSize={"small"} />
              </IconButton>
            </IgTooltip>
          )}
        </div>
      </Grid>
    </Grid>
  );
};
